import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconTextFormatNumber(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 7C5 6.44772 4.55228 6 4 6C3.44772 6 3 6.44772 3 7V12C3 12.5523 3.44772 13 4 13H9V17C9 17.5523 9.44772 18 10 18C10.5523 18 11 17.5523 11 17V12V7C11 6.44772 10.5523 6 10 6C9.44772 6 9 6.44772 9 7V11H5V7ZM13.2875 17.7125C13.4792 17.9042 13.7167 18 14 18H20C20.2833 18 20.5208 17.9042 20.7125 17.7125C20.9042 17.5208 21 17.2833 21 17C21 16.7167 20.9042 16.4792 20.7125 16.2875C20.5208 16.0958 20.2833 16 20 16H15V13H19C19.55 13 20.0208 12.8042 20.4125 12.4125C20.8042 12.0208 21 11.55 21 11V8C21 7.45 20.8042 6.97917 20.4125 6.5875C20.0208 6.19583 19.55 6 19 6H14C13.7167 6 13.4792 6.09583 13.2875 6.2875C13.0958 6.47917 13 6.71667 13 7C13 7.28333 13.0958 7.52083 13.2875 7.7125C13.4792 7.90417 13.7167 8 14 8H19V11H15C14.45 11 13.9792 11.1958 13.5875 11.5875C13.1958 11.9792 13 12.45 13 13V17C13 17.2833 13.0958 17.5208 13.2875 17.7125Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
